module.exports = __webpack_public_path__ + "static/media/img-cropper.061d2de2.jpg";